export { default as basicCustomInsightActions } from './basic'
export { default as basicCustomInsightConsts } from './basicConsts'
export { default as exportCustomInsightActions } from './emailExport'
export { default as diagramCustomInsightActions } from './diagram'
export { default as chartCustomInsightActions } from './chart'
export { default as inputParamsCustomInsightActions } from './inputParams'
export { default as mapCustomInsightActions } from './map'
export { default as saveCustomInsightActions } from './save'
export { default as tableCustomInsightActions } from './table'
export { default as searchCustomInsightActions } from './search'